import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, Users, CreditCard, BarChart, CheckCircle, Star } from 'lucide-react';

const EventosPage = () => {
  const features = [
    'Sistema completo de gestão de eventos',
    'Inscrições online automatizadas',
    'Controlo de pagamentos integrado',
    'Certificados digitais automáticos',
    'Relatórios em tempo real',
    'Aplicação móvel para participantes'
  ];

  const benefits = [
    { icon: Users, title: 'Gestão de Participantes', desc: 'Controlo total de inscrições e check-in' },
    { icon: CreditCard, title: 'Pagamentos Seguros', desc: 'Múltiplas formas de pagamento integradas' },
    { icon: BarChart, title: 'Analytics Avançado', desc: 'Métricas detalhadas de performance' },
    { icon: Calendar, title: 'Agendamento Flexível', desc: 'Ferramentas para eventos recorrentes' }
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-green-600 to-green-800 text-white py-20 pt-32">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">Unisales-Eventos</h1>
              <p className="text-xl mb-8 text-green-100">
                Organize eventos memoráveis com a nossa plataforma completa de gestão.
                Da inscrição ao feedback, tudo automatizado para eventos de sucesso.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-white text-green-700 px-8 py-3 rounded-full font-semibold hover:bg-green-50 transition duration-300">
                  Agendar Demonstração
                </button>
                <Link to="/contact" className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-green-700 transition duration-300">
                  Fale Conosco
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl font-bold mb-6">Gestão Completa de Eventos</h2>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    O Unisales-Eventos é a solução definitiva para organizadores que procuram eficiência e profissionalismo.
                    Gira todos os aspectos do seu evento, desde a criação até o pós-evento, com ferramentas
                    intuitivas e poderosas.
                  </p>
                  <ul className="space-y-3">
                    {features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                  <div className="text-center">
                    <Calendar className="w-16 h-16 text-green-600 mx-auto mb-4" />
                    <h3 className="text-2xl font-bold mb-4">Eventos de Sucesso</h3>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center">
                        <div className="text-3xl font-bold text-green-600">10+</div>
                        <p className="text-sm text-gray-600">Eventos organizados</p>
                      </div>
                      <div className="text-center">
                        <div className="text-3xl font-bold text-green-600">95%</div>
                        <p className="text-sm text-gray-600">Satisfação dos clientes</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">Benefícios Principais</h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Tudo que precisa para eventos inesquecíveis
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => {
                const IconComponent = benefit.icon;
                return (
                  <div key={index} className="text-center p-6 rounded-xl hover:shadow-lg transition duration-300">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <IconComponent className="w-8 h-8 text-green-600" />
                    </div>
                    <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">O que os nossos clientes dizem</h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <blockquote className="text-lg text-gray-700 mb-4">
                  "O Unisales-Eventos simplificou completamente a nossa organização de conferências.
                  Conseguimos automatizar 80% dos processos manuais e os nossos participantes adoraram a experiência."
                </blockquote>
                <cite className="text-gray-600 font-semibold">
                  João Santos, Organizador de Eventos - EventPro
                </cite>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-green-600 to-teal-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Pronto para eventos incríveis?</h2>
            <p className="text-xl mb-8 text-green-100">
              Descubra como podemos transformar a sua organização de eventos.
            </p>
            <button className="bg-white text-green-700 px-8 py-3 rounded-full font-semibold hover:bg-green-50 transition duration-300">
              Agendar Demonstração Gratuita
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default EventosPage;
